import { createApi } from '@reduxjs/toolkit/query/react';

import {
  RequestMessage,
  RequestQuestion,
  SupplierRequestMatch,
} from '@scaleup/models';
import { baseQuery } from './baseQuery';
import { TagTypes } from './tagTypes';

export const supplierRequestMatchApi = createApi({
  reducerPath: 'supplierRequestMatchApi',
  baseQuery: baseQuery,
  tagTypes: [TagTypes.supplierRequestMatches],
  endpoints: (builder) => ({
    getSupplierRequestMatches: builder.query<SupplierRequestMatch[], void>({
      query: () => '/supplier_request_match',
      providesTags: [TagTypes.supplierRequestMatches],
    }),
    getSrmQuestions: builder.query<RequestQuestion[], string>({
      query: (matchId) => `/supplier_request_match/${matchId}/question`,
      providesTags: [TagTypes.supplierRequestMatchQuestion],
    }),
    createSrmQuestions: builder.mutation<
      void,
      { matchId: string; questions: string[] }
    >({
      query: ({ matchId, questions }) => ({
        url: `/supplier_request_match/${matchId}/question`,
        method: 'POST',
        body: [...questions],
      }),
      invalidatesTags: [TagTypes.supplierRequestMatchQuestion],
    }),
    srmOptIn: builder.mutation<void, { matchId: string; optIn: boolean }>({
      query: ({ matchId, optIn }) => ({
        url: `/supplier_request_match/${matchId}`,
        method: 'POST',
        body: { optIn },
      }),
      invalidatesTags: [TagTypes.supplierRequestMatches],
    }),
    answerQuestions: builder.mutation<
      void,
      {
        matchId: string;
        answers: {
          [questionId: string]: string;
        };
      }
    >({
      query: ({ matchId, answers }) => ({
        url: `/supplier_request_match/${matchId}`,
        method: 'POST',
        body: { answers },
      }),
      invalidatesTags: [TagTypes.supplierRequestMatchQuestion],
    }),
    createSrmMessage: builder.mutation<
      void,
      { matchId: string; message: string }
    >({
      query: ({ matchId, message }) => ({
        url: `/supplier_request_match/${matchId}/message`,
        method: 'POST',
        body: { message },
      }),
      invalidatesTags: [TagTypes.supplierRequestMatchQuestion],
    }),
    getSrmMessages: builder.query<RequestMessage[], string>({
      query: (matchId) => `/supplier_request_match/${matchId}/message`,
      providesTags: [TagTypes.supplierRequestMatchQuestion],
    }),
    dealStatusSrm: builder.mutation<
      void,
      { matchId: string; dealWon: boolean }
    >({
      query: ({ matchId, dealWon }) => ({
        url: `/supplier_request_match/${matchId}`,
        method: 'POST',
        body: { dealWon },
      }),
      invalidatesTags: [TagTypes.supplierRequestMatches],
    }),
  }),
});

export const {
  useGetSupplierRequestMatchesQuery,
  useCreateSrmQuestionsMutation,
  useGetSrmQuestionsQuery,
  useSrmOptInMutation,
  useAnswerQuestionsMutation,
  useCreateSrmMessageMutation,
  useGetSrmMessagesQuery,
  useDealStatusSrmMutation,
} = supplierRequestMatchApi;
